import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { addTimeOffApprovalsAsync, ApproveSelectedAsync, RejectSelectedAsync, getAllTimeOffApprovalEntriesAsync, getAllTimeOffApprovedEntriesAsync, updateisTimeOffApprovaltab } from "./TimeOffApprovalSlice";
import TimeOffApprovalItem from "./TimeOffApprovalItem";
import TimeOffApprovalFilter from "./TimeOffApprovalFilter";
import OffCanvas from '../../../common/OffCanvas';
import { useTranslation } from "react-i18next";
import Select, { StylesConfig } from 'react-select';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import CustomPagination from "../../../common/Pagination";
import { getPageSizeArray, getFilteredList, paginationStyles, getValueFromResource } from "../../../common/timeLiveFunction";
import { ShowSwalWithConfirmationMessage } from "../../../common/SweetAlert";
import moment from "moment";
import { ShowToast } from "../../../common/Toastr";
import Loader from "../../../common/Loader";
import PageSizeSelect from "../../../common/PageSizeSelect";
import clsx from "clsx";
import TimeOffApprovedItems from "./TimeOffApprovedItems";
const TimeOffApproval = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const generalObject = {
        "name": getValueFromResource("Filters", dispatch, t),
        "width": "500px",
        "componentName": <TimeOffApprovalFilter t={t} />
    }

    const { timeOffApprovalList, isLoading, isReload, optionTimeOffTypesValue, optionApproverEmployeeValue, startDate, endDate, timeOffApprovedList, isTimeOffApprovaltab } = useAppSelector((state) => state.timeOffApproval);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, accountPreferenceList, maxMenuHeight } = useAppSelector((state) => state.globalState);
    const modalAttachmentRef = useRef<any>(null);
    const [pageSize, setPageSize] = useState(10);
    const [pageSizeApproved, setPageSizeApproved] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageApproved, setCurrentPageApproved] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermApproved, setSearchTermApproved] = useState('');
    const [isShowTimeOffInDays, setIsShowTimeOffInDays] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const encoded = params.get("data");
    const parsedState = React.useMemo(() => {
        const encoded = params.get("data");
        return encoded ? JSON.parse(decodeURIComponent(encoded)) : {};
    }, [encoded]);
    const { widgetFilters = null, fromDashboard = false } = parsedState;
    // const { widgetFilters, fromDashboard } = location.state || {};
    const options: any = getPageSizeArray();
    const [tab, setTab] = useState('TimeOffApprovalList');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId')

    useLayoutEffect(() => {
        
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };
        if (accountPreferenceList.length > 0) {
            setIsShowTimeOffInDays(accountPreferenceList[0].IsShowTimeOffInDays)
        }

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        setTab('TimeoffApprovalList');
        if (isReload) {
             let objFilters;
            objFilters ={
                EmployeeId: widgetFilters?.AccountEmployeeId[0] ? widgetFilters?.AccountEmployeeId[0] : optionApproverEmployeeValue,
                StartDate: widgetFilters?.IncludeDateRange ? widgetFilters?.DateRange?.startDate : moment(startDate).format('MM-DD-YYYY'),
                EndDate: widgetFilters?.IncludeDateRange ? widgetFilters?.DateRange?.endDate : moment(endDate).format('MM-DD-YYYY')
            }

            // dispatch(getAllTimeOffApprovalEntriesAsync({ AccountTimeOffTypeId: optionTimeOffTypesValue, TimeOffAccountEmployeeId: optionApproverEmployeeValue, IncludeDateRange: false, StartDate: moment(startDate).format('MM-DD-YYYY'), EndDate: moment(endDate).format('MM-DD-YYYY') }));
            // dispatch(getAllTimeOffApprovedEntriesAsync({ AccountTimeOffTypeId: optionTimeOffTypesValue, TimeOffAccountEmployeeId: optionApproverEmployeeValue, IncludeDateRange: true, StartDate: moment(startDate).subtract(1, 'months').format('MM-DD-YYYY'), EndDate: moment(endDate).add(1, 'months').format('MM-DD-YYYY') }));
            dispatch(getAllTimeOffApprovalEntriesAsync({ AccountTimeOffTypeId: optionTimeOffTypesValue, TimeOffAccountEmployeeId: objFilters?.EmployeeId, IncludeDateRange: false, StartDate: objFilters?.StartDate, EndDate: objFilters?.EndDate }));
            dispatch(getAllTimeOffApprovedEntriesAsync({ AccountTimeOffTypeId: optionTimeOffTypesValue, TimeOffAccountEmployeeId: objFilters?.EmployeeId, IncludeDateRange: true, StartDate: objFilters?.StartDate, EndDate: objFilters?.EndDate }));
        }
    }, [isReload]);

    useEffect(() => {
        let objFilters;
            objFilters ={
                EmployeeId: widgetFilters?.AccountEmployeeId[0] || 0,
                IncludeDateRange: widgetFilters?.IncludeDateRange ??  false,
                StartDate: widgetFilters?.IncludeDateRange ? widgetFilters?.DateRange?.startDate : moment(startDate).format('MM-DD-YYYY'),
                EndDate: widgetFilters?.IncludeDateRange ? widgetFilters?.DateRange?.endDate : moment(endDate).format('MM-DD-YYYY')
            }

        // dispatch(getAllTimeOffApprovalEntriesAsync({ AccountTimeOffTypeId: optionTimeOffTypesValue, TimeOffAccountEmployeeId: 0, IncludeDateRange: false, StartDate: moment(startDate).format('MM-DD-YYYY'), EndDate: moment(endDate).format('MM-DD-YYYY') }));
        // dispatch(getAllTimeOffApprovedEntriesAsync({ AccountTimeOffTypeId: optionTimeOffTypesValue, TimeOffAccountEmployeeId: 0, IncludeDateRange: true, StartDate: moment(startDate).subtract(1, 'months').format('MM-DD-YYYY'), EndDate: moment(endDate).add(1, 'months').format('MM-DD-YYYY') }));
        dispatch(getAllTimeOffApprovalEntriesAsync({ AccountTimeOffTypeId: optionTimeOffTypesValue, TimeOffAccountEmployeeId: objFilters?.EmployeeId, IncludeDateRange: objFilters?.IncludeDateRange, StartDate: objFilters?.StartDate, EndDate: objFilters?.EndDate }));
        dispatch(getAllTimeOffApprovedEntriesAsync({ AccountTimeOffTypeId: optionTimeOffTypesValue, TimeOffAccountEmployeeId: objFilters?.EmployeeId, IncludeDateRange: objFilters?.IncludeDateRange, StartDate: objFilters?.StartDate, EndDate: objFilters?.EndDate }));
    }, [dispatch]);

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };
    const handlePageChangeApproved = (pageNumber: any) => {
        setCurrentPageApproved(pageNumber);
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };
    const handleSearchApproved = (event: any) => {
        const { value } = event.target;
        setSearchTermApproved(value);
        setCurrentPageApproved(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };

    const handlePageSizeChangeApproved = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSizeApproved(Number(value));
        setCurrentPageApproved(1);
    };

    const filteredData = getFilteredList(timeOffApprovalList, searchTerm);
    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = timeOffApprovalList.length;
    const recordsFiltered = filteredData.length;


    const filteredDataApproved = getFilteredList(timeOffApprovedList, searchTermApproved);
    const indexOfLastItemApproved = currentPageApproved * pageSizeApproved;
    const indexOfFirstApproved = indexOfLastItemApproved - pageSizeApproved;
    const currentItemsApproved = filteredDataApproved.slice(indexOfFirstApproved, indexOfLastItemApproved);
    const totalItemsApproved = timeOffApprovedList.length;
    const recordsFilteredApproved = filteredDataApproved.length;

    const handleApprovedClick = (e: any) => {
        e.preventDefault();
        ShowSwalWithConfirmationMessage(`Are you sure you want to Approve this record?`, "", `Yes, Proceed`)
            .then((result) => {
                if (result) {
                    dispatch(ApproveSelectedAsync(timeOffApprovalList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "201" ?
                                ShowToast("Approved Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    const handleRejectedClick = (e: any) => {
        e.preventDefault();
        ShowSwalWithConfirmationMessage(`Are you sure you want to Reject this record?`, "", `Yes, Proceed`)
            .then((result) => {
                if (result) {
                    dispatch(RejectSelectedAsync(timeOffApprovalList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "201" ?
                                ShowToast("Rejected Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }
    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Timeoff Approvals')} */}
                        {getValueFromResource('Time Off Approvals', dispatch, t)}
                    </h3>
                    {tab === "TimeoffApprovalList" && (
                        <div className="card-toolbar align-items-center">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    placeholder=
                                    // {t('Search')}
                                    {getValueFromResource('Search', dispatch, t)}
                                    className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                    data-kt-user-table-filter="search"

                                />
                                <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </div>
                            <div className='h-35px w-1px mx-1'></div>
                            <div className="d-flex align-items-center">
                                {/* <Select
                                styles={paginationStyles}
                                maxMenuHeight={maxMenuHeight}
                                options={options}
                                value={options.find((option: any) => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                                <PageSizeSelect onChange={handlePageSizeChange} />

                            </div>
                            {(currentItems.length > 0) && (
                                <>
                                    <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                    <div>
                                        <CustomPagination
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                            pageSize={pageSize}
                                            totalItems={totalItems}
                                            start={(currentPage - 1) * pageSize}
                                            t={t}
                                            recordsFiltered={recordsFiltered}
                                        />
                                    </div>
                                </>
                            )}
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <a id="kt_OffCanvas"
                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content=
                                // {t("Filters")}
                                {getValueFromResource('Filters', dispatch, t)}
                                data-tooltip-place="bottom">
                                <i className="bi bi-filter fs-3 iconColor"></i>
                            </a>
                            {IsEdit ? (
                                <>
                                    <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                    <button
                                        type="button"
                                        style={{ marginRight: '2px', display: timeOffApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                        className={`btn btn-sm btn-outline me-2 mb-0 btn-active-light-success text-success fs-7`}
                                        onClick={(e: any) => handleApprovedClick(e)}
                                    >
                                        <i className="bi bi-check fs-3 text-success"></i>
                                        {/* {t('Approve Selected')} */}
                                        {getValueFromResource('Approve Selected', dispatch, t)}
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn btn-sm btn-outline me-0 mb-0 btn-active-light-danger text-danger fs-7`}
                                        onClick={(e: any) => handleRejectedClick(e)}
                                        style={{ marginRight: '2px', display: timeOffApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                    >
                                        <i className="bi bi-x fs-3 text-danger"></i>
                                        {/* {t('Reject Selected')} */}
                                        {getValueFromResource('Reject Selected', dispatch, t)}
                                    </button>
                                </>
                            ) : null}
                        </div>
                    )}

                    {tab === "TimeoffApprovedList" && (
                        <div className="card-toolbar align-items-center">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    value={searchTermApproved}
                                    onChange={handleSearchApproved}
                                    placeholder={getValueFromResource('Search', dispatch, t)}
                                    className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                    data-kt-user-table-filter="search"

                                />
                                <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </div>
                            <div className='h-35px w-1px mx-1'></div>
                            <div className="d-flex align-items-center">
                                <PageSizeSelect onChange={handlePageSizeChangeApproved} />

                            </div>

                            {(currentItemsApproved.length > 0) && (
                                <>
                                    <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                    <div>
                                        <CustomPagination
                                            currentPage={currentPageApproved}
                                            onPageChange={handlePageChangeApproved}
                                            pageSize={pageSizeApproved}
                                            totalItems={totalItemsApproved}
                                            start={(currentPageApproved - 1) * pageSizeApproved}
                                            t={t}
                                            recordsFiltered={recordsFilteredApproved}
                                        />
                                    </div>
                                </>
                            )}
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <a id="kt_OffCanvas"
                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content={getValueFromResource('Filters', dispatch, t)}
                                data-tooltip-place="bottom">
                                <i className="bi bi-filter fs-3 iconColor"></i>
                            </a>

                        </div>
                    )}
                </div>
                {/* <div className="card-body" > */}
                <div className="card-Report-body">
                    <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist' style={{ marginTop: 8 }}>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'TimeoffApprovalList' })}
                                onClick={() => {
                                    setTab('TimeoffApprovalList');
                                    dispatch(updateisTimeOffApprovaltab(true));
                                }}
                                role='tab'
                                style={{ fontWeight: 500 }}
                            >
                                {/* {t("Timesheet Approvals")} */}
                                {getValueFromResource('Time Off Approvals', dispatch, t)}
                            </a>
                        </li>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'TimeoffApprovedList' })}
                                onClick={() => {
                                    setTab('TimeoffApprovedList');
                                    dispatch(updateisTimeOffApprovaltab(false));
                                }}
                                role='tab'
                                style={{ fontWeight: 500 }}
                            >
                                {/* {t("Timeoff Approvals")} */}
                                {getValueFromResource('Time Off Approved', dispatch, t)}
                            </a>
                        </li>
                    </ul>
                    <div className='tab-content pt-0' style={{ marginTop: 8 }}>
                        <div className={clsx('tab-pane', { active: tab === 'TimeoffApprovalList' })}>
                            <div className="table-responsive">
                                <TimeOffApprovalItem timeOffApprovalList={currentItems} t={t} IsEdit={IsEdit} isShowTimeOffInDays={isShowTimeOffInDays} />
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'TimeoffApprovedList' })}>
                            <div className="table-responsive">
                                <TimeOffApprovedItems timeOffApprovedList={currentItemsApproved} t={t} IsEdit={IsEdit} isShowTimeOffInDays={isShowTimeOffInDays} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <OffCanvas
                obj={generalObject}
            />
        </>
    )
}

export default TimeOffApproval;



